import { Navigate, Outlet } from 'react-router-dom';
import {useUser} from "../../contexts/UserContext";

const ProtectedRouteWithStatus = ({ requiredStatus }) => {
    const { user } = useUser();

    if (!user || !requiredStatus.includes(user.status)) {
        const redirectLink = user ? `/unauthorized/${user.status}` : '/login';
        return <Navigate to={redirectLink} replace />;
    }

    return <Outlet />;
};

export default ProtectedRouteWithStatus;